import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import VueClipboard from 'vue-clipboard2';
import VueMoment from 'vue-moment';
import WebCam from 'vue-web-cam';
import moment from 'moment-timezone';
import 'animate.css/animate.min.css';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';

import accessMixin from './utils/accessMixin';

Vue.config.productionTip = false;

Vue.mixin(accessMixin);

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueTheMask);

VueClipboard.config.autoSetContainer = true; // fix to working with modals
Vue.use(VueClipboard);
Vue.use(WebCam);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
